// index.tsx
import { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import RootLayout from './layouts/RootLayout';
import App from './App';
import Home from './Home';
import Login from './Login';
import { AuthProvider } from './AuthContext';
import { ResponsiveProvider } from './contexts/ResponsiveContext';
import { UnsavedChangesProvider } from './contexts/UnsavedChangesContext';
import ProtectedRoutes from './utils/protectedRoutes';
import ApiRequestCleaner from './components/ApiRequestCleaner';

const Contact = lazy(() => import('./Contact'));
const BuyCoffee = lazy(() => import('./pages/BuyCoffee'));
const StudentApp = lazy(() => import('./student/StudentApp'));
const StudentClasses = lazy(() => import('./student/StudentClasses'));
const TeacherSchedulingProcess = lazy(() => import('./teacher/TeacherSchedulingProcess'));
const MultiViewPage = lazy(() => import('./teacher/MultiViewPage'));
const Classes = lazy(() => import('./Classes'));
const Register = lazy(() => import('./auth/Register'));
const RegistrationSuccess = lazy(() => import('./auth/RegistrationSuccess'));
const Profile = lazy(() => import('./components/Profile'));
const Impressum = lazy(() => import('./pages/Impressum'));
const Datenschutz = lazy(() => import('./pages/Datenschutz'));
const AvVertrag = lazy(() => import('./pages/AvVertrag'));
const ForgotPassword = lazy(() => import('./auth/ForgotPassword'));
const UpdatePassword = lazy(() => import('./auth/UpdatePassword'));
const NotFound = lazy(() => import('./NotFound'));
const HilfePage = lazy(() => import('./hilfe/HilfePage'));
const HilfeArtikelSeite = lazy(() => import('./hilfe/HilfeArtikelSeite'));

// StrictMode für die Entwicklung deaktivieren, um doppelte API-Aufrufe zu vermeiden
// In der Produktion sollte StrictMode wieder aktiviert werden
const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  // <React.StrictMode> - temporär auskommentiert
    <AuthProvider>
      <ResponsiveProvider>
        {/* UnsavedChangesProvider muss im Router liegen (useNavigate fürs zentrale Modal) */}
        <Router>
          <UnsavedChangesProvider>
            <ApiRequestCleaner />
            <ProtectedRoutes>
            <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<RootLayout />}>
                <Route index element={<Home />} />
                <Route path="app" element={<App />} />
                <Route path="contact" element={<Contact />} />
                <Route path="hilfe" element={<HilfePage />} />
                <Route path="hilfe/:artikelId" element={<HilfeArtikelSeite />} />
                <Route path="buy-coffee" element={<BuyCoffee />} />
                <Route path="student" element={<StudentApp />} />
                <Route path="student/classes" element={<StudentClasses />} />
                <Route path="scheduling" element={<TeacherSchedulingProcess />} />
                <Route path="multi-view" element={<MultiViewPage />} />
                <Route path="me/classes/teacher" element={<Classes />} />
                <Route path="me/classes/teacher/:classId" element={<Classes />} />
                <Route path="login" element={<Login />} />
                <Route path="register" element={<Register />} />
                <Route path="register/:registerShortcut" element={<Register />} />
                <Route path="registration-success" element={<RegistrationSuccess />} />
                {/* <Route path="register/class/:classId" element={<Register />} /> */}
                <Route path="*" element={<NotFound />} />
                <Route path="profile" element={<Profile />} />
                <Route path="impressum" element={<Impressum />} />
                <Route path="datenschutz" element={<Datenschutz />} />
                <Route path="av-vertrag" element={<AvVertrag />} />
                <Route path="forgot-password" element={<ForgotPassword />} />
                <Route path="update-password" element={<UpdatePassword />} />
              </Route>
            </Routes>
            </Suspense>
          </ProtectedRoutes>
          </UnsavedChangesProvider>
        </Router>
      </ResponsiveProvider>
    </AuthProvider>
  // </React.StrictMode>
);
